import React, { useState } from "react";
import { Button, Modal } from "reactstrap";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../../helperFunctions";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";
import CheckBox from "../../Forms/CheckBox/CheckBox";
import { Customer_Block } from "../../../../redux/slices/payoutSlice";

const BlockPayoutCustomerModal = (props) => {
  const { blockCustomer, isBlockCustomerId, onCloseBlockCustomerModal, onGet } =
    props;

  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [alsoBlockDeposit, setAlsoBlockDeposit] = useState(false);

  const dispatch = useDispatch();

  const onClose = () => {
    setAlsoBlockDeposit(false);
    setIsButtonLoading(false);
    onCloseBlockCustomerModal();
  };

  const Block_customer = async () => {
    try {
      setIsButtonLoading(true);
      let Payload = {
        withdrawalId: isBlockCustomerId,
        blockDeposit: alsoBlockDeposit ? 1 : 0,
      };
      let response = await dispatch(Customer_Block(Payload)).unwrap();
      responseToaster(response);
      if (!!response) {
        onClose();
        onGet();
      }
      setIsButtonLoading(false);
    } catch (err) {
      setIsButtonLoading(false);
    }
  };

  return (
    <Modal isOpen={blockCustomer} toggle={onClose} centered={true}>
      <div className="modal-header">
        <h3 className="modal-title mt-0">Block Customer</h3>
        <i onClick={onClose} className="fa-solid fa-xmark"></i>
      </div>
      <div className="modal-body">
        <div>
          <p>Are you sure you want to block customer?</p>
        </div>
        <div className="d-flex">
          <CheckBox
            value={alsoBlockDeposit}
            onChange={(e) => {
              setAlsoBlockDeposit(e);
            }}
            label="Also block deposit?"
          />
        </div>
      </div>
      <div className="modal-footer">
        <div className="d-flex justify-content-end button-space">
          <Button className="graybutton" onClick={onClose}>
            Cancel
          </Button>
          <CustomeButton
            className="submitbutton"
            onClick={Block_customer}
            isButtonLoading={isButtonLoading}
          >
            Submit
          </CustomeButton>
        </div>
      </div>
    </Modal>
  );
};

export default BlockPayoutCustomerModal;
